import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useColorModeValue } from 'utils/hooks';
import { dateSave } from 'reducers/slices/date';
import { toggleCalendar } from 'reducers/slices/calendarstatus';
import { ColorButton } from 'components/utility/Buttons';
import Modal from 'components/utility/Modal';
import { Stack, XStack, useTheme } from 'tamagui';
import { ShadowCard } from 'components/base/General';
import loadable from '@loadable/component';
const CalendarPicker = loadable(() => import('react-native-calendar-picker'));

// TODO make universal
const dateFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const CalendarModal = props => {
  const theme = useTheme();
  const date = useSelector(state => state.date);
  const [startDate, setStartDate] = useState(date?.start_date);
  const [endDate, setEndDate] = useState(date?.end_date);
  const dispatch = useDispatch();
  const r = React.useRef(null);
  const TodayBG = useColorModeValue('#FFF', 'gray.500');
  const mainColor = useColorModeValue('black', '#FFF');
  const _toggleCalendar = () => {
    dispatch(toggleCalendar(false));
  };
  const onDateChange = async (date, type) => {
    // TODO a cleaner way to do this without null check?
    if (type === 'END_DATE' && date !== null) {
      setEndDate(date.format(dateFormat));
    } else if (type === 'END_DATE' && date === null) {
      setEndDate(date);
    } else {
      setStartDate(date.format(dateFormat));
      setEndDate(null);
    }
  };
  const clearDates = () => {
    setStartDate(null);
    setEndDate(null);
    r.current?.resetSelections();
  };
  const saveDates = () => {
    dispatch(toggleCalendar(false));
    dispatch(dateSave({
      start_date: startDate,
      end_date: endDate ? endDate : null
    }));
  };

  // TODO TAMAGUI
  return /*#__PURE__*/React.createElement(Modal, {
    backdropOpacity: 0,
    isVisible: props.calendarstatus,
    onBackdropPress: _toggleCalendar,
    animationIn: "fadeInUp",
    animationOut: "fadeOutDown"
  }, /*#__PURE__*/React.createElement(ShadowCard, {
    left: "7%",
    top: 60,
    $sm: {
      left: '13%',
      top: 0
    },
    $md: {
      left: '-5%',
      top: 10
    },
    $lg: {
      left: '-2%',
      top: 55
    },
    $xl: {
      left: '12%'
    },
    height: 350,
    width: 300,
    pt: 10,
    pb: 5,
    borderRadius: 15,
    shadow: 5,
    justifyContent: "space-between",
    bg: theme.calendarBG
  }, /*#__PURE__*/React.createElement(CalendarPicker, {
    ref: r,
    selectedStartDate: date.start_date,
    selectedEndDate: date.end_date,
    selectedDayColor: "#c9150f",
    selectedDayTextColor: "#FFFFFF",
    todayBackgroundColor: TodayBG,
    todayTextStyle: {
      color: mainColor
    },
    textStyle: {
      color: mainColor
    },
    onDateChange: onDateChange,
    allowRangeSelection: true,
    allowBackwardRangeSelect: true,
    width: 300,
    height: 400
  }), /*#__PURE__*/React.createElement(XStack, {
    px: 5,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(ColorButton, {
    title: "Clear",
    onPress: clearDates,
    width: 75,
    height: 35,
    fontSize: "$xs"
  }), /*#__PURE__*/React.createElement(ColorButton, {
    title: "Save",
    onPress: saveDates,
    width: 75,
    height: 35,
    fontSize: "$xs"
  }))));
};